import axios from "axios";
import config, { OPEN_URLS } from "../config";
import { isValidToken } from "./auth.service";
import { handleApiError } from "../utils/ErrorHandler/ErrorHandler";
import store from "../store/store";

const isLocalRequest = config.env === "local" ? 1 : 0;

const api = axios.create({
  baseURL: config[`${config.env}DomainUrl`],
  headers: {
    "Content-Type": "application/json",
    "is-local-request": isLocalRequest,
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (apiConfig) => {
    // Attach the token from localStorage or wherever you're storing it
    const token = localStorage.getItem("accessToken") ?? "";  
    if (OPEN_URLS.includes(apiConfig.url || "")) {
      return apiConfig;
    }
    if (!isValidToken()) {
      if (window.location.pathname.includes("/user-consent")) {
        return apiConfig;
      }
      window.location.replace("/");
      localStorage.clear();
      sessionStorage.clear();
      return Promise.reject(new Error("Token has expired"));
    } else {
      apiConfig.headers.Authorization = `Bearer ${token}`;
    }
    return apiConfig;
  },
  (error) =>
    Promise.reject(error instanceof Error ? error : new Error(String(error))),
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    let errorDetails;

    if (response) {
      errorDetails = {
        status: response.status,
        message: response.data?.error?.message || "An error occurred",
        details: response.data?.error?.details || [],
      };
      handleApiError(store.dispatch, { error: errorDetails });
      return Promise.reject(
      Object.assign(new Error(errorDetails.message), {
          error: errorDetails,
        })

      );
    }
    errorDetails = {
      status: null,
      message: error?.message || "An unknown error occurred",
    };
    handleApiError(store.dispatch, { error: errorDetails });
    return Promise.reject(
      Object.assign(new Error(errorDetails.message), {
          error: errorDetails,
        })
    );

  }
);

export default api;
